// extracted by mini-css-extract-plugin
export var changeIcon = "_72-4";
export var container = "_72-0";
export var divider = "_72-7";
export var externalLinkIcon = "_72-1";
export var green = "_72-5";
export var helpCircleIcon = "_72-3";
export var iconButton = "_72-2";
export var red = "_72-6";